// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W3DMT2mExqjGJ88navSs {
    width: 211px;
}

.XSiPRgP9siHw7PZj1JDY {
    box-sizing: border-box;
    width: 100%;
    padding: 12px 12px 12px 28px;
    background: var(--gray-header-background);
    line-height: 26px;
}

.UTjg7FaKqdxl28vkr7fs {
    width: 100%;
    padding: 1px 12px;
    background: var(--gray-header-background);
    line-height: 26px;
    box-sizing: border-box;
}

.J7RAPgZLmo_0729_19J6 {
    display: flex;
    justify-content: end;
    margin-top: 66px;
}

.P4ostEopW5y8_bA5OxO_ {
    padding: 13px 33px;
    box-sizing: border-box;
    border: 2px solid var(--white);
    background: var(--white);
    color: var(--green);
    font-weight: 600;
    margin-right: 20px;
}

.XiDGok2ZVLjWpUg6KDCw {
    padding: 13px 33px;
    box-sizing: border-box;
    border: 2px solid var(--green);
    background: var(--white);
    color: var(--green);
    font-weight: 600;
    margin-right: 20px;
}

._q0BdWZ2A5nXXRaoGAnE {
    display: flex;
    width: 100%;
}

.Aujq5s9SKR9npXxcfwtw {
    display: flex;
    padding: 13px 13px 13px 0;
    border: none;
    background: var(--white);
    color: var(--green);
    font-weight: 600;
    line-height: 24px;
}

.Aujq5s9SKR9npXxcfwtw > svg {
    margin-right: 6px;
}

.gta8RDJPvI9jxUn2yEmg {
    height: 38px;
    width: 38px;
}

.x7VbkLT3uCffieu2EXId {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 38px;
    width: 38px;
    border: none;
    background: var(--white);
}

.OMClDpvYVtnWkFdnGs4m {
    height: 22px;
}

.Gs0XaZPQEwbqAhYLX0vF {
    height: 40px;
    width: 100%;
    padding: 2px 8px;
    border-radius: 2px;
    border: 1px solid var(--light-gray);
    margin: 1px;
}

.WpawdP8crUgnN2NhAeqA {
    border: 2px solid var(--red-error);
    margin: 0;
}

.iY3A7lv08GS4_MDLdIoY {
    margin-top: 26px;
}

.nd1nklTkePczfvjmXZiO {
    display: flex;
    justify-content: end;
    width: 100%;
    color: var(--red-error);
}
`, "",{"version":3,"sources":["webpack://./src/jotpa/jotpa.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,4BAA4B;IAC5B,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,yCAAyC;IACzC,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,uBAAuB;AAC3B","sourcesContent":[".jotpaLogo {\n    width: 211px;\n}\n\n.infoList {\n    box-sizing: border-box;\n    width: 100%;\n    padding: 12px 12px 12px 28px;\n    background: var(--gray-header-background);\n    line-height: 26px;\n}\n\n.info {\n    width: 100%;\n    padding: 1px 12px;\n    background: var(--gray-header-background);\n    line-height: 26px;\n    box-sizing: border-box;\n}\n\n.buttons {\n    display: flex;\n    justify-content: end;\n    margin-top: 66px;\n}\n\n.cancelButton {\n    padding: 13px 33px;\n    box-sizing: border-box;\n    border: 2px solid var(--white);\n    background: var(--white);\n    color: var(--green);\n    font-weight: 600;\n    margin-right: 20px;\n}\n\n.previousButton {\n    padding: 13px 33px;\n    box-sizing: border-box;\n    border: 2px solid var(--green);\n    background: var(--white);\n    color: var(--green);\n    font-weight: 600;\n    margin-right: 20px;\n}\n\n.emailRow {\n    display: flex;\n    width: 100%;\n}\n\n.addEmailButton {\n    display: flex;\n    padding: 13px 13px 13px 0;\n    border: none;\n    background: var(--white);\n    color: var(--green);\n    font-weight: 600;\n    line-height: 24px;\n}\n\n.addEmailButton > svg {\n    margin-right: 6px;\n}\n\n.removeEmailPlaceholder {\n    height: 38px;\n    width: 38px;\n}\n\n.removeEmailButton {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 38px;\n    width: 38px;\n    border: none;\n    background: var(--white);\n}\n\n.postitoimipaikka {\n    height: 22px;\n}\n\n.emailInput {\n    height: 40px;\n    width: 100%;\n    padding: 2px 8px;\n    border-radius: 2px;\n    border: 1px solid var(--light-gray);\n    margin: 1px;\n}\n\n.errorInput {\n    border: 2px solid var(--red-error);\n    margin: 0;\n}\n\n.copyKayntiosoite {\n    margin-top: 26px;\n}\n\n.submitError {\n    display: flex;\n    justify-content: end;\n    width: 100%;\n    color: var(--red-error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jotpaLogo": `W3DMT2mExqjGJ88navSs`,
	"infoList": `XSiPRgP9siHw7PZj1JDY`,
	"info": `UTjg7FaKqdxl28vkr7fs`,
	"buttons": `J7RAPgZLmo_0729_19J6`,
	"cancelButton": `P4ostEopW5y8_bA5OxO_`,
	"previousButton": `XiDGok2ZVLjWpUg6KDCw`,
	"emailRow": `_q0BdWZ2A5nXXRaoGAnE`,
	"addEmailButton": `Aujq5s9SKR9npXxcfwtw`,
	"removeEmailPlaceholder": `gta8RDJPvI9jxUn2yEmg`,
	"removeEmailButton": `x7VbkLT3uCffieu2EXId`,
	"postitoimipaikka": `OMClDpvYVtnWkFdnGs4m`,
	"emailInput": `Gs0XaZPQEwbqAhYLX0vF`,
	"errorInput": `WpawdP8crUgnN2NhAeqA`,
	"copyKayntiosoite": `iY3A7lv08GS4_MDLdIoY`,
	"submitError": `nd1nklTkePczfvjmXZiO`
};
export default ___CSS_LOADER_EXPORT___;
